(function () {
    const DIVISOR = 4;

    const scale = function (node, factor, keys) {
        if (Array.isArray(node)) {
            node.forEach((item) => scale(item, factor, keys));
            return;
        }
        if (!node || typeof node !== "object") {
            return;
        }
        Object.keys(node).forEach((key) => {
            const value = node[key];
            if (keys.indexOf(key) !== -1) {
                if (typeof value === "number") {
                    node[key] = Number.isInteger(value) ? Math.floor(value * factor) : value * factor;
                } else if (Array.isArray(value) && value.every((v) => typeof v === "number")) {
                    node[key] = value.map((v) => (Number.isInteger(v) ? Math.floor(v * factor) : v * factor));
                }
            }
            scale(value, factor, keys);
        });
    };

    scale(RewardsConfig, 1 / DIVISOR, ["hard", "hardPrice"]);

    const roundToTen = function (value) {
        return Math.round(value / 10) * 10;
    };

    const roundHardToTen = function (obj) {
        if (obj && typeof obj.hard === "number") {
            obj.hard = roundToTen(obj.hard);
        }
    };
    RewardsConfig.PromotionSale.forEach((item) => roundHardToTen(item.reward));
    RewardsConfig.Supplies.rewards.forEach(roundHardToTen);
    RewardsConfig.ChainSale.forEach((item) => roundHardToTen(item.reward));

    const roundToFive = function (value) {
        return Math.round(value / 5) * 5;
    };
    Object.values(RewardsConfig.Boosters).forEach((booster) => {
        if (booster && typeof booster.hard === "number") {
            booster.hard = roundToFive(booster.hard);
        }
    });

    cleverapps.InitByFeature["legacy_coins"] = function () {
        Product.HARD_TO_USD *= DIVISOR;

        Products.cheapProduct.reward = { hard: 1 };
        Products.gold500.reward = { hard: 500 };
        Products.gold1800.reward = { hard: 1800 };
        Products.gold3800.reward = { hard: 3800 };
        Products.gold6000.reward = { hard: 6000 };
        Products.gold25000.reward = { hard: 25000 };

        if (VirtualProducts.stickers0) {
            VirtualProducts.stickers0.price = roundToTen(RewardsConfig.stickers0.hardPrice);
            VirtualProducts.stickers1.price = roundToTen(RewardsConfig.stickers1.hardPrice);
            VirtualProducts.stickers2.price = roundToTen(RewardsConfig.stickers2.hardPrice);
        }
    };
}());
